import { useCallback, useMemo } from 'react'
import { useBoolean } from 'react-use'

/**
 * Make open-close toggle states easier
 * for things like Drawers
 */
export function usePopoverState(initialState = false) {
  const [isOpen, setIsOpen] = useBoolean(initialState)

  const close = useCallback(() => {
    setIsOpen(false)
  }, [setIsOpen])

  const open = useCallback(() => {
    setIsOpen(true)
  }, [setIsOpen])

  const toggle = useCallback(() => {
    setIsOpen((prevIsOpen: boolean) => !prevIsOpen)
  }, [setIsOpen])

  return useMemo(
    () => ({
      isOpen,
      close,
      open,
      toggle
    }),
    [close, isOpen, open, toggle]
  )
}
